/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Donut Small.
 * @export
 */
export const ICON_DONUT_SMALL = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.083 20.82C11.083 21.46 10.493 21.94 9.87301 21.8C5.40301 20.8 2.08301 16.79 2.08301 12C2.08301 7.21002 5.40301 3.20002 9.87301 2.20002C10.493 2.06002 11.083 2.54002 11.083 3.18002V20.82ZM13.113 3.18002V9.99002C13.113 10.54 13.563 10.99 14.113 10.99H20.903C21.543 10.99 22.023 10.4 21.883 9.77002C21.033 6.01002 18.083 3.05002 14.333 2.20002C13.703 2.06002 13.113 2.54002 13.113 3.18002ZM13.113 20.82V14.01C13.113 13.46 13.563 13.01 14.123 13H20.913C21.543 13 22.033 13.6 21.893 14.22C21.043 17.98 18.093 20.95 14.333 21.8C13.703 21.94 13.113 21.46 13.113 20.82Z" />
  </svg>
);
